import { jsxs as r, Fragment as t, jsx as C } from "react/jsx-runtime";
const l = () => /* @__PURE__ */ r(t, { children: [
  /* @__PURE__ */ C(
    "path",
    {
      d: "M18.8205 1.01302C19.6192 0.938239 20.4532 1.18047 21.066 1.87068C22.1986 3.1463 21.7923 4.85611 20.9333 5.99157C20.3809 6.72191 19.5715 7.52828 18.9048 8.15322C18.5674 8.46942 18.2591 8.74605 18.0273 8.95162C17.9777 8.99554 17.9286 9.04056 17.8794 9.08567C17.7804 9.17648 17.6808 9.26784 17.5766 9.3512C17.543 9.37803 17.3901 9.49989 17.1538 9.49989C16.9175 9.49989 16.7646 9.37803 16.7311 9.3512C16.6235 9.26515 16.5217 9.16944 16.4205 9.07428C16.3714 9.02811 16.3222 8.98194 16.2728 8.9372C16.0401 8.72657 15.7311 8.44412 15.3937 8.12453C14.7269 7.4928 13.9219 6.69023 13.3818 6.00128C12.4895 4.8678 12.1142 3.14047 13.2416 1.87068C13.855 1.17991 14.6915 0.938345 15.4903 1.01301C16.0803 1.06817 16.6599 1.29425 17.1551 1.64431C17.6514 1.29475 18.2305 1.06827 18.8205 1.01302Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ C(
    "path",
    {
      d: "M4 22.1923C4 22.6384 4.37608 23 4.84 23H17.16C17.6239 23 18 22.6384 18 22.1923C18 19.4151 15.9674 17.1374 13.2284 16.3223C14.2969 15.6042 15 14.3842 15 13C15 10.7909 13.2091 9 11 9C8.79086 9 7 10.7909 7 13C7 14.3842 7.70308 15.6042 8.7716 16.3223C7.52269 16.6939 6.42064 17.3697 5.59119 18.2583C5.15488 17.8736 4.89953 17.5206 4.73846 17.1436C4.47497 16.5268 4.39401 15.6866 4.53046 14.2427C4.58988 13.6139 4.08841 13.0595 3.41039 13.0044C2.73237 12.9493 2.13455 13.4144 2.07513 14.0431C1.93001 15.5787 1.9656 16.8585 2.44697 17.9854C2.8395 18.9043 3.48459 19.6234 4.33735 20.2801C4.11869 20.8793 4 21.5212 4 22.1923Z",
      fill: "currentColor"
    }
  )
] });
export {
  l as default
};
